// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShakeOutlinedSvg from "@ant-design/icons-svg/es/asn/ShakeOutlined";
import AntdIcon from '../components/AntdIcon';

var ShakeOutlined = function ShakeOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShakeOutlinedSvg
  }));
};

ShakeOutlined.displayName = 'ShakeOutlined';
export default React.forwardRef(ShakeOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ShakeOutlined.js
// module id = 1781
// module chunks = 0